export function isArray(maybeArray) {
  return Array.isArray(maybeArray);
}